<template>
  <modal :show.sync="modalEdit">
    <h4 slot="header" class="title title-up">
      {{ $t("app.modules.mail_configuration.edit.title") }}
    </h4>
    <ValidationObserver ref="formEdit" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(editRow)">
        <div class="row">
          <div class="col-sm-12">
            <ValidationProvider
              name="minLength"
              rules="required|min:5"
              v-slot="{ passed, failed }"
            >
              <fg-input
                type="text"
                :error="
                  failed
                    ? 'La longitud mínima para el email de salida es de 5  '
                    : null
                "
                :hasSuccess="passed"
                name="minLength"
                :label="
                  $t('app.modules.mail_configuration.headers.outgoing_mail')
                "
                v-model="item.mailFrom"
              >
              </fg-input>
            </ValidationProvider>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <ValidationProvider
              name="minLength"
              rules="required|min:5"
              v-slot="{ passed, failed }"
            >
              <fg-input
                type="password"
                :error="
                  failed
                    ? 'La longitud mínima para el Contraseña es de 5 '
                    : null
                "
                :hasSuccess="passed"
                name="minLength"
                :label="$t('app.modules.mail_configuration.headers.password')"
                v-model="item.mailPass"
              >
              </fg-input>
            </ValidationProvider>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <ValidationProvider
              name="minLength"
              rules="required|min:5"
              v-slot="{ passed, failed }"
            >
              <fg-input
                type="text"
                :error="
                  failed ? 'La longitud mínima para el SMTP es de 2 ' : null
                "
                :hasSuccess="passed"
                name="minLength"
                :label="
                  $t('app.modules.mail_configuration.headers.smtp_server')
                "
                v-model="item.mailSmtp"
              >
              </fg-input>
            </ValidationProvider>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <ValidationProvider
              name="minLength"
              rules="required|min:2"
              v-slot="{ passed, failed }"
            >
              <fg-input
                type="number"
                :error="
                  failed ? 'La longitud mínima para el puerto es de 2 ' : null
                "
                :hasSuccess="passed"
                name="minLength"
                :label="$t('app.modules.mail_configuration.headers.port')"
                v-model="item.mailSmtpPort"
              >
              </fg-input>
            </ValidationProvider>
          </div>
        </div>

        <div class="col-sm-6 form-group has-label">
          <div class="row">
            <label style="margin-left: 15px">{{
              $t("app.modules.mail_configuration.headers.use_ssl")
            }}</label>
          </div>
          <template>
            <n-switch v-model="item.mailSSL">
              <i class="now-ui-icons ui-1_check" slot="on"></i>
              <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
            </n-switch>
          </template>
        </div>
        <div
          slot="footer"
          style="margin-top: 10px; padding-top: 20px;border-top: outset;"
          class="text-right"
        >
          <n-button class="pull-left btn-secondary" @click.native="cancelEdit()">{{
            $t("app.buttons.cancel")
          }}</n-button>
          <n-button native-type="submit" type="primary">{{
            $t("app.buttons.save")
          }}</n-button>
        </div>
      </form>
    </ValidationObserver>
  </modal>
</template>
<script>
import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";
export default {
  components: {},
  data() {
    return {
      item: {
        idEmpresa: 0,
        mailFrom: "",
        mailPass: "",
        mailSmtp: "",
        mailSmtpPort: 0,
        mailSSL: true
      },
      payload: {
        idEmpresa: 0,
        mailFrom: "",
        mailPass: "",
        mailSmtp: "",
        mailSmtpPort: 0,
        mailSSL: true
      },
      switches: {
        withIconsOn: true
      },
      minLength: "",
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false
      },
      modalEdit: false
    };
  },
  mounted() {
    EventBus.$on("mailconfiguration-edit", async item => {
      this.item = item;
      this.item.mailPass = "";
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      this.$swal.close();
      this.modalEdit = true;
    });
  },
  methods: {
    cancelEdit() {
      this.modalEdit = false;
      this.$refs.formEdit.reset();
    },
    async editRow() {
      this.payload.idEmpresa = this.item.idEmpresa;
      this.payload.mailFrom = this.item.mailFrom;
      this.payload.mailPass = this.item.mailPass;
      this.payload.mailSmtp = this.item.mailSmtp;
      this.payload.mailSmtpPort = this.item.mailSmtpPort;
      this.payload.mailSSL = this.item.mailSSL;
      console.log(this.payload);
      await this.$http
        .put(route("MailConfiguration/updateMailConfiguration"), this.payload)
        .then(
          async response => {
            console.log(response);
            if (response.body.code === 200) {
              this.notifyMessage("success", this.$t("app.promps.save_success"));
              this.cancelEdit();
              EventBus.$emit("reload-items");
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    }
  }
};
</script>
<style>
.extended-forms .el-select {
  width: 100%;
  margin-bottom: 30px;
}
.card .alert {
  position: relative !important;
  width: 100%;
}

.modal-content .modal-header {
  padding-bottom: 24px;
  box-shadow: 0px 2px 5px 0px #00000021;
}

.modal-content .modal-body + .modal-footer {
  padding-top: 20px !important;
  background-color: #efefefb3;
}
</style>
